import { useField, useFormikContext } from 'formik';
import React from 'react';

import styled from '@emotion/styled';

import ActiveRadioButtonCircle from '../Icons/ActiveRadioButtonCircle';
import InActiveRadioButtonCircle from '../Icons/InActiveRadioButtonCircle';
import { FieldErrorInfo } from './FormField';

interface CustomInlinePlainRadioFieldGroupProps {
  children: React.ReactNode;
  name: string;
  label?: string;
}

export const CustomInlinePlainRadioFieldGroup: React.FC<
  CustomInlinePlainRadioFieldGroupProps
> = ({ children, name, label }) => {
  const { errors, touched } = useFormikContext<any>();

  return (
    <RadioGroupWrapper>
      {label && <InputLabel>{label}</InputLabel>}
      <RadioGroup>
        {React.Children.map(children, (child: any) => {
          return React.cloneElement(child, {
            ...child.props,
          });
          // }
        })}
      </RadioGroup>

      {errors[name] && touched[name] ? (
        <CustomFieldErrorInfo>
          {(errors as any)[name].capitalize()}
        </CustomFieldErrorInfo>
      ) : null}
    </RadioGroupWrapper>
  );
};

export interface CustomPlainRadioProps {
  label?: any;
  id?: string;
  name: string;
  children?: any;
  className?: string;
  value?: string;
}

export const CustomPlainRadio: React.FC<CustomPlainRadioProps> = ({
  children,
  className,
  ...props
}) => {
  const [field] = useField({ ...props, type: 'radio' });

  return (
    <RadioWrapper className={className}>
      <label>
        <input type='radio' {...field} {...props} />
        <RadioItemDiv>
          {children}
          <RadioItemActiveIcon className='active'>
            <ActiveRadioButtonCircle />
          </RadioItemActiveIcon>
          <RadioItemInactiveIcon className='inactive'>
            <InActiveRadioButtonCircle />
          </RadioItemInactiveIcon>
        </RadioItemDiv>
      </label>
    </RadioWrapper>
  );
};

const RadioItemDiv = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  border-radius: 6px;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  height: 40px;
`;

export const InputLabel = styled.label`
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  margin-bottom: 10px;
  color: black;
  user-select: none;
`;
const RadioItemActiveIcon = styled.div`
  display: none;
`;

const RadioItemInactiveIcon = styled.div``;

const RadioWrapper = styled.div`
  & > label {
    width: 100%;
    display: grid;

    & > * {
      grid-column: 1;
      grid-row: 1;
    }
  }

  & > label input[type='radio'] {
    visibility: hidden;
  }

  & > label input[type='radio']:checked ~ div > .active {
    display: block;
  }

  & > label input[type='radio']:checked ~ div > .inactive {
    display: none;
  }

  & > * {
    cursor: pointer;
  }
`;

const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0px;
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 12px;

  & > * {
  }
`;

const CustomFieldErrorInfo = styled(FieldErrorInfo)`
  margin-top: 0px;
`;
